import React from 'react';
import NavUser from '../components/navUser'

export default function MainScreenUser({history}) { 
  return (
    <>
    <NavUser path ={history.location.pathname} history={history} />
    <button className="btn btn-outline-light btn-block w-100 mb-2" onClick={(event)=>history.push('video')}>Video</button>
    </>
  );
}